import React, { useEffect } from 'react';
import { trackPage } from '../../../services/helpers';
import '../../../styles/style.scss';
import { Auth } from '../Auth/Auth';

export const Login = () => {
  useEffect(() => {
    trackPage("Login Page")
  }, [])
  return <Auth type="login" />
}
